import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../../styles/Login.css";

function Login() {
  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${BASE_URL}/api/login`, {
        userid,
        password,
      });

      localStorage.setItem("userId", res.data.id);
      localStorage.setItem("userRole", res.data.role.toString());
      localStorage.setItem("token", res.data.token);

      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${res.data.token}`;

      // ✅ Fetch full user info after login
      const userInfo = await axios.get(`${BASE_URL}/api/users/${res.data.id}`, {
        headers: { Authorization: `Bearer ${res.data.token}` },
      });

      localStorage.setItem("me", JSON.stringify(userInfo.data));

      // ⭐ ALSO store emp_roles as separate localStorage item
      if (Array.isArray(userInfo.data.emp_roles)) {
        localStorage.setItem(
          "emp_roles",
          JSON.stringify(userInfo.data.emp_roles)
        );
      }

      navigate(res.data.role === 1 ? "/admin" : "/userhome");
    } catch (err) {
      console.error("Login error:", err.response?.data || err.message);
      alert(
        err.response?.data?.message ||
          "Login failed. Please check your credentials."
      );
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-wrapper">
        <h3 className="mb-4">Login</h3>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label>Email</label>
            <input
              type="text"
              className="form-control"
              value={userid}
              onChange={(e) => setUserid(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Password</label>
            <div className="input-group">
              <input
                type={passwordVisible ? "text" : "password"}
                name="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="input-group-text"
                onClick={() => setPasswordVisible(!passwordVisible)}
                style={{ cursor: "pointer" }}
              >
                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="text-end mt-2">
              <button
                type="button"
                className="btn btn-link p-0"
                style={{ fontSize: "0.9rem" }}
                onClick={() => navigate("/forgot-password")}
              >
                Forgot password?
              </button>
            </div>
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
